module.exports = __webpack_public_path__ + "static/media/LectureSeriesImg3.bf1d412f.jpeg";